import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CloneMachine from "./CloneMachine";
import CreateMachine from "./CreateMachine";

const resolveTypeFromSearch = (search) => {
  const params = new URLSearchParams(search || "");
  const tab = (params.get("tab") || "").toLowerCase().trim();

  if (tab === "new" || tab === "create" || tab === "1") return 1;

  if (tab === "clone" || tab === "0") return 0;

  return 0;
};

export default function NewMachine({ setParam }) {
  const location = useLocation();
  const history = useHistory();

  const initialType = useMemo(() => resolveTypeFromSearch(location.search), [location.search]);
  const [type, setType] = useState(initialType);

  useEffect(() => {
    const next = resolveTypeFromSearch(location.search);
    setType(next);
  }, [location.search]);

  const setTab = useCallback(
    (nextType) => {
      setType(nextType);

      const params = new URLSearchParams(location.search || "");
      params.set("tab", nextType === 1 ? "new" : "clone");

      history.replace({
        pathname: location.pathname,
        search: `?${params.toString()}`,
      });
    },
    [history, location.pathname, location.search]
  );

  return (
    <>
      <div>
        <ul className="nav nav-tabs machine-tabs mb-3">
          <li className="nav-item">
            <button
              className={`nav-link btn ${type === 0 ? "active" : ""}`}
              onClick={() => type !== 0 && setTab(0)}
              tabIndex="0"
              type="button"
            >
              Klonuj
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link btn ${type === 1 ? "active" : ""}`}
              onClick={() => type !== 1 && setTab(1)}
              tabIndex="0"
              type="button"
            >
              Utwórz nowy
            </button>
          </li>
        </ul>
      </div>

      {type === 0 && <CloneMachine setParam={setParam} />}
      {type === 1 && <CreateMachine setParam={setParam} />}
    </>
  );
}